import React from 'react';

import styles from './contentList.module.scss';

const ContentList = props => {
    return (
        <div className={`col-12 col-md-6 order-1 ${styles.content}`}>
            <h3 className={`${styles.title} mt16`}>
                <div>{props.title}</div>
            </h3>
            <p>
                <ul>
                    {props.children}
                </ul>
            </p>
        </div>
    );
};

export default ContentList;
